var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProgressbarFinance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_97"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_96"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_95"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_94"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_93"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_92"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_91"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_90"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_89"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_88"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_87"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_86"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_85"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_84"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_83"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_82"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_81"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_80"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_79"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_78"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_77"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_76"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_75"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_74"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_73"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_72"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_71"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_70"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_69"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_68"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_67"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_66"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_65"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_64"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_63"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_62"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_61"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_60"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_59"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M150.731,19.001c-72.233,0-131,58.767-131,131s58.767,131,131,131s131-58.767,131-131 S222.965,19.001,150.731,19.001z M150.282,44.354l0.74,0.526l48.183,34.468c0.567,0.406,0.698,1.195,0.291,1.762 c-0.405,0.568-1.191,0.699-1.759,0.294l-47.448-33.94l-74.48,53.785h149.023l-19.328-14.236 c-0.562-0.413-0.682-1.204-0.269-1.764c0.414-0.563,1.205-0.684,1.766-0.269l25.52,18.797H67.991L150.282,44.354z M156.872,74.4 h0.006c0.78,0,1.413,0.631,1.415,1.411c0.002,0.782-0.63,1.417-1.411,1.42l-10.165,0.029c-0.055,0.547-0.101,1.12-0.133,1.727 c0.023,0.525,0.062,1.023,0.104,1.505l10.062-0.031h0.005c0.78,0,1.413,0.632,1.415,1.411c0.004,0.782-0.629,1.417-1.411,1.42 l-9.692,0.028c1.331,6.921,5.07,7.829,10.313,8.275c0.78,0.065,1.356,0.752,1.291,1.531c-0.063,0.738-0.682,1.294-1.409,1.294 c-0.04,0-0.08-0.001-0.124-0.005c-5.896-0.502-11.303-1.806-12.934-11.088l-5.119,0.016h-0.006c-0.78,0-1.413-0.631-1.414-1.411 c-0.002-0.78,0.629-1.417,1.411-1.418l4.772-0.014c-0.038-0.469-0.07-0.952-0.094-1.453c-0.004-0.047-0.002-0.093,0-0.14 c0.028-0.568,0.07-1.113,0.12-1.639l-4.667,0.014h-0.005c-0.78,0-1.413-0.632-1.415-1.412c-0.004-0.781,0.631-1.417,1.411-1.419 l5.068-0.016c1.726-9.1,7.09-10.353,12.933-10.813c0.781-0.06,1.46,0.521,1.523,1.302c0.059,0.778-0.521,1.46-1.302,1.521 c-5.164,0.406-8.87,1.274-10.281,7.982L156.872,74.4z M228.677,110.98v2.526H71.899v-2.526H228.677z M228.677,234.467H71.899 v-2.527h156.777V234.467z M238.712,115.638c0,8.361-6.801,15.162-15.16,15.162h-1.73v5.441c0,2.088-1.698,3.79-3.788,3.79h-1.593 l1.189,62.988h11.047c1.395,0,2.525,1.133,2.525,2.528v19.079c0,1.396-1.131,2.528-2.525,2.528h-38.48 c-1.395,0-2.525-1.131-2.525-2.528c0-1.395,1.131-2.526,2.525-2.526h35.952v-14.027H74.425V222.1h102.416 c1.395,0,2.523,1.131,2.523,2.526c0,1.396-1.129,2.528-2.523,2.528H71.899c-1.394,0-2.524-1.131-2.524-2.528v-19.079 c0-1.395,1.131-2.528,2.524-2.528h13.566l1.191-62.988h-1.593c-2.091,0-3.791-1.702-3.791-3.79V130.8h-3.368 c-8.359,0-15.158-6.801-15.158-15.162v-3.393c0-1.396,1.131-2.527,2.525-2.527c1.396,0,2.529,1.131,2.529,2.527v3.393 c0,5.573,4.532,10.108,10.104,10.108h145.646c5.574,0,10.107-4.535,10.107-10.108v-3.393c0-1.396,1.131-2.527,2.527-2.527 c1.395,0,2.525,1.131,2.525,2.527V115.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M136.133,136.241V130.8h-24.028v5.441c0,2.088-1.698,3.79-3.79,3.79h-1.591l1.188,62.988h32.415 l1.189-62.988h-1.591C137.835,140.03,136.133,138.329,136.133,136.241z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M190.993,136.241V130.8h-24.032v5.441c0,2.088-1.698,3.79-3.788,3.79h-1.593l1.189,62.988h32.417 l1.189-62.988h-1.593C192.695,140.03,190.993,138.329,190.993,136.241z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#137F7B",
    points: "104.198,140.03 89.184,140.03 87.994,203.019 87.969,204.287 105.409,204.287 105.386,203.019 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#137F7B",
    d: "M83.803,130.8v5.441c0,0.697,0.567,1.262,1.262,1.262h1.639h19.974h1.638 c0.698,0,1.264-0.565,1.264-1.262V130.8v-0.923H83.803V130.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#137F7B",
    points: "159.055,140.03 144.041,140.03 142.853,203.019 142.828,204.287 160.266,204.287 160.242,203.019  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#137F7B",
    d: "M138.661,130.8v5.441c0,0.697,0.567,1.262,1.264,1.262h1.638h19.969h1.642 c0.696,0,1.263-0.565,1.263-1.262V130.8v-0.923h-25.774V130.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#137F7B",
    points: "213.914,140.03 198.899,140.03 197.716,203.019 197.69,204.287 215.126,204.287 215.1,203.019 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#137F7B",
    d: "M193.521,129.877v0.923v5.441c0,0.697,0.565,1.262,1.263,1.262h1.64h19.969h1.642 c0.696,0,1.26-0.565,1.26-1.262V130.8v-0.923H193.521z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M150.731,11.001c-76.645,0-139,62.355-139,139s62.355,139,139,139s139-62.355,139-139 S227.376,11.001,150.731,11.001z M150.731,281.001c-72.233,0-131-58.767-131-131s58.767-131,131-131s131,58.767,131,131 S222.965,281.001,150.731,281.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M236.187,109.718c-1.396,0-2.527,1.131-2.527,2.527v3.393c0,5.573-4.533,10.108-10.107,10.108H77.905 c-5.571,0-10.104-4.535-10.104-10.108v-3.393c0-1.396-1.133-2.527-2.529-2.527c-1.395,0-2.525,1.131-2.525,2.527v3.393 c0,8.361,6.799,15.162,15.158,15.162h3.368v5.441c0,2.088,1.7,3.79,3.791,3.79h1.593l-1.191,62.988H71.899 c-1.394,0-2.524,1.133-2.524,2.528v19.079c0,1.396,1.131,2.528,2.524,2.528h104.941c1.395,0,2.523-1.131,2.523-2.528 c0-1.395-1.129-2.526-2.523-2.526H74.425v-14.027h151.724V222.1h-35.952c-1.395,0-2.525,1.131-2.525,2.526 c0,1.396,1.131,2.528,2.525,2.528h38.48c1.395,0,2.525-1.131,2.525-2.528v-19.079c0-1.395-1.131-2.528-2.525-2.528H217.63 l-1.189-62.988h1.593c2.09,0,3.788-1.702,3.788-3.79V130.8h1.73c8.359,0,15.16-6.801,15.16-15.162v-3.393 C238.712,110.849,237.581,109.718,236.187,109.718z M87.969,204.287l0.025-1.268l1.189-62.988h15.015l1.188,62.988l0.023,1.268 H87.969z M86.703,137.503h-1.639c-0.694,0-1.262-0.565-1.262-1.262V130.8v-0.923h25.775v0.923v5.441 c0,0.697-0.565,1.262-1.264,1.262h-1.638H86.703z M140.326,203.019h-32.415l-1.188-62.988h1.591c2.092,0,3.79-1.702,3.79-3.79 V130.8h24.028v5.441c0,2.088,1.702,3.79,3.792,3.79h1.591L140.326,203.019z M142.828,204.287l0.024-1.268l1.188-62.988h15.014 l1.188,62.988l0.023,1.268H142.828z M141.563,137.503h-1.638c-0.696,0-1.264-0.565-1.264-1.262V130.8v-0.923h25.774v0.923v5.441 c0,0.697-0.566,1.262-1.263,1.262h-1.642H141.563z M195.187,203.019H162.77l-1.189-62.988h1.593c2.09,0,3.788-1.702,3.788-3.79 V130.8h24.032v5.441c0,2.088,1.702,3.79,3.79,3.79h1.593L195.187,203.019z M197.69,204.287l0.025-1.268l1.184-62.988h15.015 l1.186,62.988l0.026,1.268H197.69z M219.293,130.8v5.441c0,0.697-0.563,1.262-1.26,1.262h-1.642h-19.969h-1.64 c-0.697,0-1.263-0.565-1.263-1.262V130.8v-0.923h25.772V130.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.899,
    y: 110.98,
    fill: "#333333",
    width: 156.777,
    height: 2.526
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.899,
    y: 231.939,
    fill: "#333333",
    width: 156.777,
    height: 2.527
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M207.001,84.979c-0.561-0.415-1.352-0.294-1.766,0.269c-0.413,0.56-0.293,1.351,0.269,1.764 l19.328,14.236H75.809l74.48-53.785l47.448,33.94c0.567,0.404,1.354,0.274,1.759-0.294c0.407-0.567,0.276-1.356-0.291-1.762 l-48.183-34.468l-0.74-0.526l-82.291,59.423h164.529L207.001,84.979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M157.42,66.446c0.78-0.06,1.36-0.742,1.302-1.521c-0.063-0.78-0.742-1.362-1.523-1.302 c-5.843,0.46-11.207,1.713-12.933,10.813l-5.068,0.016c-0.78,0.001-1.415,0.638-1.411,1.419c0.002,0.78,0.635,1.412,1.415,1.412 h0.005l4.667-0.014c-0.05,0.525-0.092,1.071-0.12,1.639c-0.002,0.047-0.004,0.093,0,0.14c0.023,0.501,0.056,0.984,0.094,1.453 l-4.772,0.014c-0.782,0.001-1.413,0.638-1.411,1.418c0.001,0.78,0.634,1.411,1.414,1.411h0.006l5.119-0.016 c1.631,9.282,7.037,10.586,12.934,11.088c0.044,0.004,0.084,0.005,0.124,0.005c0.728,0,1.346-0.556,1.409-1.294 c0.065-0.779-0.511-1.466-1.291-1.531c-5.242-0.446-8.981-1.354-10.313-8.275l9.692-0.028c0.782-0.003,1.415-0.638,1.411-1.42 c-0.002-0.779-0.635-1.411-1.415-1.411h-0.005l-10.062,0.031c-0.042-0.482-0.08-0.98-0.104-1.505 c0.032-0.606,0.078-1.179,0.133-1.727l10.165-0.029c0.781-0.003,1.413-0.638,1.411-1.42c-0.002-0.78-0.635-1.411-1.415-1.411 h-0.006l-9.733,0.028C148.55,67.721,152.256,66.853,157.42,66.446z"
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_58"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_57"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_56"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_55"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_54"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_53"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_52"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_51"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_49"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_48"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_47"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_46"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_44"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_43"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_42"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_41"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_40"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_39"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_38"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_37"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_36"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_35"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_34"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgressbarFinance);
export default __webpack_public_path__ + "static/media/icon_progressbar_finance.e14bdc4edf3c81d6589582eab924fa46.svg";
export { ForwardRef as ReactComponent };